// Tracks the 10-minute date reservation a saved draft gets (holdUntil from the
// server) and exposes a live countdown for the notice on the apply/edit pages.
// holdInfo ({ used, max, lockedUntil }) says how many of the applicant's
// reservations for these dates are used and until when they have to wait for more.
export default {
  data() {
    return {
      holdUntil: null,
      holdNow: Date.now(),
      holdInfo: null,
    };
  },

  computed: {
    holdActive() {
      return !!this.holdUntil && this.holdUntil.getTime() > this.holdNow;
    },
    holdExpired() {
      return !!this.holdUntil && !this.holdActive;
    },
    holdUntilTime() {
      if (!this.holdUntil) return "";
      return this.holdUntil.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit" });
    },
    holdTimeLeft() {
      if (!this.holdActive) return "0:00";
      const secs = Math.ceil((this.holdUntil.getTime() - this.holdNow) / 1000);
      return Math.floor(secs / 60) + ":" + String(secs % 60).padStart(2, "0");
    },
    holdsUsed() {
      return this.holdInfo ? this.holdInfo.used : 0;
    },
    holdsMax() {
      return this.holdInfo ? this.holdInfo.max : 6;
    },
    // All reservations for these dates are used up and the waiting period is running.
    holdLocked() {
      return !!this.holdInfo && !!this.holdInfo.lockedUntil && new Date(this.holdInfo.lockedUntil).getTime() > this.holdNow;
    },
    holdLockedUntilText() {
      if (!this.holdLocked) return "";
      return new Date(this.holdInfo.lockedUntil).toLocaleString("en-IN", {
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "2-digit",
      });
    },
  },

  created() {
    this.holdTicker = null;
  },

  beforeDestroy() {
    clearInterval(this.holdTicker);
  },

  methods: {
    // info is optional: leave it out to keep the current reservation count.
    setHold(value, info) {
      const until = value ? new Date(value) : null;
      this.holdUntil = until && !isNaN(until.getTime()) ? until : null;
      if (info !== undefined) this.holdInfo = info || null;
      this.holdNow = Date.now();
      clearInterval(this.holdTicker);
      this.holdTicker = null;
      if (this.holdActive) {
        this.holdTicker = setInterval(() => {
          this.holdNow = Date.now();
          if (!this.holdActive) {
            clearInterval(this.holdTicker);
            this.holdTicker = null;
          }
        }, 1000);
      }
    },
  },
};
